import React from 'react';
import { PlusCircleIcon, ClockIcon, RefreshCwIcon, UserIcon } from 'lucide-react';
interface HomeScreenProps {
  onNewCollection: () => void;
  onNavigate: (tab: 'history' | 'sync') => void;
}
export function HomeScreen({
  onNewCollection,
  onNavigate
}: HomeScreenProps) {
  return <div className="flex flex-col p-4 gap-6" data-id="element-149">
      {/* Greeting Section */}
      <div className="flex items-center justify-between bg-white p-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-150">
        <div className="flex items-center gap-3" data-id="element-151">
          <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden border-2" style={{
          borderColor: '#3d99d2'
        }} data-id="element-152">
            <UserIcon className="w-6 h-6 text-gray-500" data-id="element-153" />
          </div>
          <div data-id="element-154">
            <p className="text-sm text-gray-500 font-medium" data-id="element-155">Bienvenido,</p>
            <h2 className="text-lg font-bold text-gray-900" data-id="element-156">Juan Pérez</h2>
          </div>
        </div>
        <div className="flex flex-col items-end" data-id="element-157">
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-158">
            <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-159"></span>
            En línea
          </span>
        </div>
      </div>

      {/* Hero Action */}
      <button onClick={onNewCollection} className="w-full h-32 rounded-2xl flex flex-col items-center justify-center gap-3 text-white shadow-lg active:scale-[0.98] transition-transform" style={{
      backgroundColor: '#134073'
    }} data-id="element-160">
        <PlusCircleIcon className="w-10 h-10" data-id="element-161" />
        <span className="text-xl font-bold" data-id="element-162">Nueva Recolección</span>
      </button>

      {/* Secondary Actions Grid */}
      <div className="grid grid-cols-2 gap-4" data-id="element-163">
        <button onClick={() => onNavigate('history')} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center justify-center gap-3 active:scale-[0.98] transition-transform" data-id="element-164">
          <div className="p-3 rounded-full bg-blue-50" style={{
          color: '#3d99d2'
        }} data-id="element-165">
            <ClockIcon className="w-7 h-7" data-id="element-166" />
          </div>
          <div className="text-center" data-id="element-167">
            <span className="block font-bold text-gray-900" data-id="element-168">Historial</span>
            <span className="text-xs text-gray-500 mt-1 block" data-id="element-169">
              12 registros hoy
            </span>
          </div>
        </button>

        <button onClick={() => onNavigate('sync')} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center justify-center gap-3 active:scale-[0.98] transition-transform relative" data-id="element-170">
          <div className="absolute top-3 right-3 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-171">
            2
          </div>
          <div className="p-3 rounded-full bg-blue-50" style={{
          color: '#3d99d2'
        }} data-id="element-172">
            <RefreshCwIcon className="w-7 h-7" data-id="element-173" />
          </div>
          <div className="text-center" data-id="element-174">
            <span className="block font-bold text-gray-900" data-id="element-175">
              Sincronización
            </span>
            <span className="text-xs text-red-500 font-medium mt-1 block" data-id="element-176">
              Pendientes
            </span>
          </div>
        </button>
      </div>

      {/* Stats Card */}
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-5 rounded-2xl border border-gray-200 mt-2" data-id="element-177">
        <h3 className="text-sm font-semibold text-gray-600 mb-1" data-id="element-178">
          Resumen del Día
        </h3>
        <div className="flex items-end gap-2" data-id="element-179">
          <span className="text-3xl font-bold" style={{
          color: '#134073'
        }} data-id="element-180">
            145
          </span>
          <span className="text-gray-600 mb-1 font-medium" data-id="element-181">
            prendas recolectadas
          </span>
        </div>
      </div>
    </div>;
}